@if (agent(); as agent) {
  <div *transloco="let t">
    <div class="pb-xs text-md font-semibold">
      {{ t('shared.damageBox.title') }}
    </div>
    <div class="mt-sm mb-lg flex items-start gap-sm">
      @if (logo(); as logo) {
        <bgo-agency-logo [logo]="logo"></bgo-agency-logo>
      } @else if (agency()?.name) {
        <cft-support-portrait [name]="agency()?.name!" size="md"></cft-support-portrait>
      } @else {
        <cft-support-portrait [name]="agent | bgoFullName" size="md"></cft-support-portrait>
      }
      <div>
        <div class="text-base font-semibold">
          @if (agency()?.name; as agency) {
            {{ agency }}
          } @else {
            {{ agent | bgoFullName }}
          }
        </div>
        <div class="text-grey-700">
          @if (damageCaseNumber(); as damageCaseNumber) {
            <div>{{ t('shared.damageBox.damageCaseNumber') }}</div>
            <div>{{ damageCaseNumber }}</div>
          } @else {
            <div>{{ t('shared.damageBox.yourAgent') }}</div>
          }
        </div>
      </div>
    </div>
    <div class="flex flex-wrap justify-start gap-sm pt-sm">
      @if (agent.phoneNumber) {
        <button class="btn btn-container space-x-xs" (click)="showContactDialog($event)">
          <fa-icon [icon]="faPhone"></fa-icon>
          <span>
            {{ agent.phoneNumber | bgoPhoneNumberMask }}
            {{ t('shared.damageBox.viewPhoneNumberLabel') }}
          </span>
        </button>
      }
      @if (agent.email) {
        <button class="btn btn-container space-x-xs" (click)="showContactDialog($event)">
          <fa-icon [icon]="faEmail"></fa-icon>
          <span>
            {{ t('shared.damageBox.emailLabel') }}
          </span>
        </button>
      }
    </div>
  </div>
}
